import { render, staticRenderFns } from "./EmployeeRegistryFileDocuments.vue?vue&type=template&id=4576d45f&"
import script from "./EmployeeRegistryFileDocuments.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegistryFileDocuments.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRegistryFileDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports